import { PATTERNS } from '../../constants/validations';

export default function(value) {
  return PATTERNS.POSTAL_CODE.test(value);
}



// WEBPACK FOOTER //
// ./src/utils/validations/postalCodeValidator.js